import type { DeepPartial, Entity, HistoryCreateBody, Vehicle } from 'models'
import type {
  IQueries,
  UpdateSchemaBody,
  VehicleListRequestOptions,
  VehiclesRequestOptions,
} from './queryInterface'
import { queryAdapter } from './queryAdapter'

const queryService = (adapter: IQueries): IQueries => ({
  getIp: async () => adapter.getIp(),

  getHolidays: async () => adapter.getHolidays(),

  getUser: async () => adapter.getUser(),

  getMongo: async (filteringEntity: Entity['id']) => adapter.getMongo(filteringEntity),

  getAllEntities: () => adapter.getAllEntities(),

  searchCompanies: (request) => adapter.searchCompanies(request),

  getCompanyById: (id: string) => adapter.getCompanyById(id),

  getAuction: async (auctionNo: string, filteringEntitiesIds: Array<Entity['id']>) =>
    adapter.getAuction(auctionNo, filteringEntitiesIds),

  getAuctionsLight: (filteringEntityId: Entity['id'], timeLine) =>
    adapter.getAuctionsLight(filteringEntityId, timeLine),

  getWaitingFilesFromEntity: async (filteringEntityId: Entity['id']) =>
    adapter.getWaitingFilesFromEntity(filteringEntityId),

  getWaitingFilesFromEntities: async (
    filteringEntitiesIds: Array<Entity['id']>,
    options?: VehiclesRequestOptions,
  ) => adapter.getWaitingFilesFromEntities(filteringEntitiesIds, options),

  getStockFromEntity: async (filteringEntityId: Entity['id']) =>
    adapter.getStockFromEntity(filteringEntityId),

  getStockFromEntities: async (
    filteringEntitiesIds: Array<Entity['id']>,
    options?: VehiclesRequestOptions,
  ) => adapter.getStockFromEntities(filteringEntitiesIds, options),

  getVehicles: async (
    filteringEntitiesIds: Array<Entity['id']>,
    key: 'no' | 'licensePlate' | 'vin',
    value: string,
    options?: VehiclesRequestOptions,
  ) => adapter.getVehicles(filteringEntitiesIds, key, value, options),

  getVehicleListLight: async (
    no: string,
    filteringEntitiesIds: Array<Entity['id']>,
    options?: VehicleListRequestOptions,
  ) => adapter.getVehicleListLight(no, filteringEntitiesIds, options),

  getVehicleListFull: async (
    no: string,
    filteringEntitiesIds: Array<Entity['id']>,
    options?: VehicleListRequestOptions,
  ) => adapter.getVehicleListFull(no, filteringEntitiesIds, options),

  getStatusesObject: async () => adapter.getStatusesObject(),

  getVehicleByNo: (no: Vehicle['no']) => adapter.getVehicleByNo(no),

  getFilesStorageUrl: (ids: Array<string>) => adapter.getFilesStorageUrl(ids),

  updateVehicle: (body: DeepPartial<Vehicle>) => adapter.updateVehicle(body),

  getSchema: async (userId: string, companyId: string) => adapter.getSchema(userId, companyId),

  updateSchema: async (body: UpdateSchemaBody) => adapter.updateSchema(body),

  getHistory: async (historyParams: string) => adapter.getHistory(historyParams),

  postReserveHistory: async (body: HistoryCreateBody) => adapter.postReserveHistory(body),
})

const currentQueryService = queryService(queryAdapter)

export { queryService, currentQueryService }
